exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pop-up__openApp[data-v-6ad35fe4]{padding:25px 15px;width:100%;text-align:center;background:#fff;position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.pop-up__openApp p[data-v-6ad35fe4]{color:#1a1a1a;font-weight:500;margin:25px 0}.pop-up__openApp a[data-v-6ad35fe4]{background:#ff8200;color:#fff;padding:10px 25px;border-radius:4px;font-weight:500}", ""]);

// exports
